import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';
import * as Constants from 'src/constants';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2022-11-09'
        tag='Kidizen'
        title='Selling on Kidizen? Use Promoted Listing To Boost Your Sales!'
      >
        <p>
          This type of listing only means expanding your reach across the accounts in Kidizen. More people would see
          your listings or items on the category, filtered, and featured pages on the platform. Having extensive
          exposure increases your chances of gaining the attention of potential customers. Of course, this comes with a
          small cost. However, this proves to be worth it when you notice how this can increase your sales by toggling a
          single button.
        </p>

        <h3>How it works</h3>
        <p>
          When you opt for a Promoted Listing, you can easily turn this on or off. Currently, it is available for iOs
          and the website. An Android version will soon come, so better to keep checking for app updates.
        </p>
        <p>
          What you can promote are clothes and shoes. The bundles and not-for-sale ones are not allowed. Take note that
          you can't choose which items to promote as well. The platform does it automatically for you – again,
          prioritizing garments and shoes. This means your other items that need promotion may not be accepted by the
          system.
        </p>
        <p>
          Up to 100 items are allowed, but Kidizen focuses on the items listed for more than two (2) weeks already if
          you have more than this number. This gives them the chance to be seen again and find the perfect buyer for
          them.
        </p>
        <p>
          There is a limit to the number of sellers allowed to promote at a time. This explains why you may receive a
          notification that Kidizen is not accepting your request at a particular time. There is no guaranteed timeframe
          for when a slot will be open again. You only need to wait a few hours before trying again. Be patient as you
          compete with hundreds of other sellers for the slots.
        </p>

        <h3>The cost of promotion</h3>
        <p>
          Promoting on the platform costs $10 for 5,000 impressions on your Kidizen account. Impressions mean the number
          of times your listing appears on an account's shopping feed. This only happens when a user uses a filter while
          browsing the shopping page. This is why you must label or categorize your items properly. You wouldn't want to
          miss out on a chance of closing a sale just because you mislabeled a listing.
        </p>
        <p>
          Now, every time your listing does show up on someone's feed, your impressions are deducted from your original
          count of 5,000. This is updated daily. You will only see the balance the following day. There is currently no
          way of knowing how many impressions a listing earned. Kidizen has no report for this yet.
        </p>
        <p>
          Additionally, there is an option of Auto-Renew, wherein if within 24 hours, your count reaches zero (0)
          balance, the platform automatically renews the impressions. But you can turn this off if you don't want to be
          automatically charged.
        </p>
        <p>
          You can also set 0.50 cents (minimum) for the daily budget of your impressions. So, make sure you keep track
          so you won't go over your expected expenses within a month.
        </p>

        <h3>Shared vs. Promoted</h3>
        <p>
          When you promote, your listing gets bumped up on people's feeds across different sorting options. On the other
          hand, "Shared Listings" only appear on the "Just In" page–meaning they are something that is "new" to the
          feed.
        </p>
        <p>
          You may want to evaluate whether you will opt for Promoted Listing (with additional cost) or Shared Listing,
          which can also be limited. It is all about reviewing your priorities and the time you have in your hands to
          market your items.
        </p>

        <h3>Benefits of promoting </h3>
        <p>
          You would want to reach more users as a seller, whether you are a long-time seller or a new seller to Kidizen.
          Having your items bumped up and shown to more people increases the chances of gaining the attention of
          different audiences. This means you would most likely find someone interested in your items, even those that
          aren't currently selling well.
        </p>
        <p>
          For those with small shops, this is highly advantageous to you. This drives traffic to your page and helps you
          gain exposure. Being noticed is your stepping stone to securing more sales.
        </p>
        <p>
          Lastly, keep in mind that only items within the app are promoted. Your listings won't get promoted anywhere
          else unless you manually share them across other marketplaces or social media accounts.
        </p>

        <h3>Reach more buyers with OneShop</h3>
        <p>
          The ultimate goal of all online sellers is to increase their sales hence features like Promoted Listing on
          Kidizen are helpful. While this is true, there are other techniques to make your business successful, like
          reaching more potential buyers across other platforms using a reliable automation app.
        </p>
        <p>
          OneShop is an automation service that acts as your all-in-one assistant trusted by thousands of sellers who
          dread the long hours of manually posting their listings on multiple marketplaces. It lets you easily
          cross-list across platforms like Poshmark, Mercari, Tradesy, Depop, eBay, and more (soon), resulting in higher
          chances of making sales even outside Kidizen.
        </p>
        <p>
          If you are keen on keeping track of your sales, OneShop has a sales tracker and goal-setting features that
          will surely help you see your progress in achieving your selling goals. Plus, you get to access its social
          community, where you can interact with thousands of other resellers about topics relevant to online selling.
        </p>
        <p>
          Give OneShop a try and test the waters with its 7-day free trial with zero risk. All you have to do is{' '}
          <a href='https://tools.oneshop.com/signup'>sign-up</a> here, and we'll text you the link to the app. Get set
          up in less than 3 minutes and experience selling more with less work.
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
